<template>
  <section>
    <!-- 审批人循环组装 -->
    <div class="clear">
      <el-form-item>
        <div class="tab-title">
          <span class="title">请选择审批人</span>
        </div>
        <div class="contact-user-list">
          <div class="user-item" v-for="user,i in selectArr" v-if="user">
            <span class="name">{{user.name}}</span>
            <span @click="deleteUsers(i)" class="iconfont icon-close1"></span>
          </div>
        </div>
        <el-button @click="addUsers()" type="primary" size="mini" icon="el-icon-circle-plus-outline">添加人员</el-button>
      </el-form-item>
    </div>

    <!-- 暂时取消固定审批人 -->
    <!-- <div class="clear" v-if="defaultApprovalUsers.length>0">
      <el-form-item>
        <div class="tab-title">
          <span class="title">固定审批领导</span>
        </div>
      </el-form-item>
      <div class="form-item left mx">
        <label> </label>
        <div class="person-room" style="margin-top:0px;" v-for="item,i in defaultApprovalUsers">
          <span class="persion-item" style="padding:0 15px;background:rgb(156, 44, 230)">
            {{item.name}}
          </span>
        </div>
      </div>
    </div> -->
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";
  export default {
    props: ['defaultApprovalUsers', 'selectArr', 'approvalSetDep'],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        // 意见与审批
        userType: 1,
      }
    },
    created() {},
    methods: {
      // 删除人员
      deleteUsers(index) {
        this.selectArr.splice(index, 1)
      },
      // 添加人员
      addUsers() {
        // this.userType = type

        let _arr = this.selectArr ? this.selectArr : []
        let _depId = this.approvalSetDep ? this.approvalSetDep : 0

        this.$store.commit('set_contactSelectArr', _arr)
        this.$store.commit('set_contactApprovalDep', _depId)

        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', false)
        // if (isSingle == "false") {
        //   this.$store.commit('set_contactSingleSelect', false)
        // } else {

        // }
      },
      getUserIds() {
        return this.selectArr.map(item => item.id).join()
      },
    },
    watch: {
      // "selectArr"() {
      //   console.log(2)
      // },
      "contactSelectArr"() {
        // console.log(this.contactSelectArr.length)
        if (this.contactSelectArr.length > 0) {
          this.selectArr = this.contactSelectArr
          this.$store.commit('set_contactSelectArr', [])
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ApprovalItemByCustom.vue